module.exports = __webpack_public_path__ + "img/2.01f711b5.png";